import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { ThemeProps } from "../../genericComponents/globalStyles";
import marked from 'marked'
import logo from '../../../assets/images/front/favicon_big.png'
import firebase from "firebase/app";


const CardContainer = ({ record, descriptionClick }) => {
    const [description, setDescription] = useState(null)
    const [imageUrl, setImageUrl] = useState(null)

    useEffect(async () => {
        if (record) {
            setDescription(record.description)
            let url = logo
            if (record.image_key)
                url = await firebase.storage().ref(`articles/${record.image_key}`).getDownloadURL()
            setImageUrl(url)
        }
    }, [record])

    const handlerDescriptionClick = ({ target }) => {
        console.log(target.textContent)
        descriptionClick(target.textContent)
    }

    return record ? (
        <ContentContainer>
            <ImageContainer>
                {<img src={imageUrl} />}
            </ImageContainer>
            <Title>
                <a href={record.website_link} target="_blank">{record.title}</a>
            </Title>
            <DescriptionContainer >
                <span>Bite Sized Bit</span>
                <div onClick={handlerDescriptionClick} dangerouslySetInnerHTML={{ __html: description }}></div>
            </DescriptionContainer>
            <LinkContainer>
                <span>Website</span>
                <div>
                    <a href={record.website_link} target="_blank">{record.website_link}</a>
                </div>
            </LinkContainer>
            <TagContainer>
                <span>Categories</span>
                <div>{record.categories?.map((value, index) => (<label key={index}>{value.category?.name}</label>))}</div>

            </TagContainer>
            <TagContainer>
                <span>Media Type</span>
                <div>{record.media_types?.map((value, index) => (<label key={index}>{value.media_type?.name}</label>))}</div>

            </TagContainer>
            <TagContainer>
                <span>Audience</span>
                <div>{record.audiences?.map((value, index) => (<label key={index}>{value.audience?.name}</label>))}</div>
            </TagContainer>
        </ContentContainer >

    ) : null
};

export default CardContainer;

const FieldContainer = styled.div`
    margin-top: 10px;
    color: ${ThemeProps.color.darkBlue};
    span {
        background:${ThemeProps.color.softPurple};
        font-size: 0.8em;
        border-radius: 3px;
        padding:3px;       
        font-weight:bold;    
    }
    p {
        --lh: 1.2em;
        line-height: var(--lh);
        margin-top:2px;
        --max-lines: 5;
        overflow: hidden;
        max-height: calc(var(--lh) * var(--max-lines));
        text-overflow: ellipsis;
        word-break:break-all;
        text-align:justify;
    }
    a {
        color: ${ThemeProps.color.darkBlue};         
    }
`

const ImageContainer = styled.div`
    width:220px; 
    height:220px;
    margin:0px auto;
    img,video{
        max-width:200px; 
        max-height:200px;
        margin: 0px auto;
        display:block;
    }
`

const LinkContainer = styled(FieldContainer)`
div {
    word-break:break-all;
    padding:3px;
    margin-top:2px;
}
`

const DescriptionContainer = styled(FieldContainer)`
div:hover{
    cursor:pointer;
}

a {
    font-weight:bold;
    white-space:nowrap;
}
`

const TagContainer = styled(FieldContainer)`
div{
    margin-top:3px;
    display:flex;
    flex-flow:row;
    flex-wrap: wrap;
}
label {
    color:${ThemeProps.color.darkBlue};
    background:${ThemeProps.color.gabaYellow};
    font-size: 0.9em;
    border-radius: 6px;
    padding:6px;
    margin-right:3px;
    margin-bottom:3px;
    
}
`

const Title = styled(FieldContainer)`
    font-size: 1.2em;
    font-weight:bold;
  `;


const ContentContainer = styled.div`
    background:${ThemeProps.color.softYellow};
    border-radius: 10px;
    width:23%;
    min-width:250px;
    padding:16px;
    margin-right: 10px;
    margin-top: 10px;
    `